// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__zzTOr","comment":"styles_comment__1Wjat"};